/* esm.sh - rxjs@7.8.1/dist/esm/internal/symbol/iterator */
function t(){return typeof Symbol!="function"||!Symbol.iterator?"@@iterator":Symbol.iterator}var r=t();export{t as getSymbolIterator,r as iterator};
//# sourceMappingURL=iterator.mjs.map